import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
var CameraIcon = function(param) {
    var fill = param.fill;
    return _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        style: {
            width: '50%',
            height: '50%'
        },
        children: _jsx("g", {
            style: {
                fill: fill
            },
            children: _jsx("svg", {
                viewBox: "0 0 24 24",
                children: _jsx("path", {
                    d: "M12,17 C9.790861,17 8,15.209139 8,13 C8,10.790861 9.790861,9 12,9 C14.209139,9 16,10.790861 16,13 C16,15.209139 14.209139,17 12,17 Z M12,15 C13.1045695,15 14,14.1045695 14,13 C14,11.8954305 13.1045695,11 12,11 C10.8954305,11 10,11.8954305 10,13 C10,14.1045695 10.8954305,15 12,15 Z M1,9 C1,7.34314575 2.34314575,6 4,6 L5.26393202,6 C5.64270408,6 5.9889672,5.78599762 6.15835921,5.4472136 L6.5527864,4.65835921 C7.06096245,3.64200713 8.0997518,3 9.23606798,3 L12.9296325,3 C13.932692,3 14.869386,3.50130341 15.4257834,4.33589941 L16.2383172,5.5547002 C16.423783,5.83289886 16.7360143,6 17.0703675,6 L20,6 C21.6568542,6 23,7.34314575 23,9 L23,18 C23,19.6568542 21.6568542,21 20,21 L4,21 C2.34314575,21 1,19.6568542 1,18 L1,9 Z M3,9 L3,18 C3,18.5522847 3.44771525,19 4,19 L20,19 C20.5522847,19 21,18.5522847 21,18 L21,9 C21,8.44771525 20.5522847,8 20,8 L17.0703675,8 C16.067308,8 15.130614,7.49869659 14.5742166,6.66410059 L13.7616828,5.4452998 C13.576217,5.16710114 13.2639857,5 12.9296325,5 L9.23606798,5 C8.85729592,5 8.5110328,5.21400238 8.34164079,5.5527864 L7.9472136,6.34164079 C7.43903755,7.35799287 6.4002482,8 5.26393202,8 L4,8 C3.44771525,8 3,8.44771525 3,9 Z"
                })
            })
        })
    });
};
var UserIcon = function(param) {
    var fill = param.fill;
    return _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        style: {
            width: '50%',
            height: '50%'
        },
        children: _jsx("g", {
            style: {
                fill: fill
            },
            children: _jsx("svg", {
                viewBox: "0 0 24 24",
                children: _jsx("path", {
                    d: "M16 14H8c-2.8 0-5 2.2-5 5v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-1.7 1.3-3 3-3h8c1.7 0 3 1.3 3 3v2c0 .6.4 1 1 1s1-.4 1-1v-2c0-2.8-2.2-5-5-5zM12 12c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5zm0-8c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3z"
                })
            })
        })
    });
};
var CheckIcon = function(param) {
    var fill = param.fill;
    return _jsx("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        style: {
            width: '100%',
            height: '100%'
        },
        children: _jsx("g", {
            style: {
                fill: fill
            },
            children: _jsxs("svg", {
                viewBox: "0 0 24 24",
                children: [
                    _jsx("path", {
                        d: "M20.7 5.3c-.4-.4-1-.4-1.4 0L9 15.6l-4.3-4.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l5 5c.2.2.4.3.7.3.3 0 .5-.1.7-.3l11-11c.4-.4.4-1 0-1.4z"
                    }),
                    _jsxs("g", {
                        fillRule: "evenodd",
                        children: [
                            _jsx("use", {}),
                            _jsx("use", {
                                fillRule: "nonzero"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var HelpIcon = function(param) {
    var fill = param.fill;
    return _jsx("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        style: {
            width: '100%',
            height: '100%'
        },
        children: _jsx("g", {
            style: {
                fill: fill
            },
            children: _jsxs("svg", {
                viewBox: "0 0 24 24",
                children: [
                    _jsx("path", {
                        d: "M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm0-5.25a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM10.2 6.4c1-.5 2.1-.5 3.1-.1 1.5.5 2.6 2 2.7 3.9 0 2.6-3.3 3.8-3.7 3.9-.1.1-.2.1-.3.1-.4 0-.8-.3-.9-.7-.2-.6.1-1.1.6-1.3.6-.3 2.3-1.1 2.3-2.1 0-.9-.5-1.7-1.3-1.9-.6-.2-1.1-.2-1.6 0s-.8.6-1 1.1c-.2.6-.8.9-1.3.7-.5-.2-.8-.8-.6-1.3.3-1 1-1.8 2-2.3z"
                    }),
                    _jsxs("g", {
                        fillRule: "evenodd",
                        children: [
                            _jsx("use", {}),
                            _jsx("use", {
                                fillRule: "nonzero"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var XIcon = function(param) {
    var fill = param.fill;
    return _jsx("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        style: {
            width: '100%',
            height: '100%'
        },
        children: _jsx("g", {
            style: {
                fill: fill
            },
            children: _jsx("svg", {
                viewBox: "0 0 24 24",
                children: _jsx("path", {
                    d: "M13.4 12l5.3-5.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L12 10.6 6.7 5.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l5.3 5.3-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l5.3-5.3 5.3 5.3c.2.2.5.3.7.3.2 0 .5-.1.7-.3.4-.4.4-1 0-1.4L13.4 12z"
                })
            })
        })
    });
};
var SolidIcon = function() {
    return _jsx("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        style: {
            width: '100%',
            height: '100%'
        }
    });
};
export { CameraIcon, UserIcon, CheckIcon, HelpIcon, XIcon, SolidIcon };
